// extracted by mini-css-extract-plugin
export var description = "Header-module--description--d655b";
export var info = "Header-module--info--f0106";
export var root = "Header-module--root--a7e98";
export var sep = "Header-module--sep--ee30c";
export var showMore = "Header-module--showMore--79bd7";
export var tagsContainer = "Header-module--tagsContainer--409ff";
export var title = "Header-module--title--1b7d5";